import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-update-ibo',
  templateUrl: './update-ibo.component.html',
  styleUrls: ['./update-ibo.component.css']
})
export class UpdateIboComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/ibo/update-ibo/update-ibo.component.ts